import React, { forwardRef, useEffect, useRef, HTMLAttributes } from "react";
import classNames from "classnames";

import { generateId } from "./generateId";
import { useBottomSheetContext } from "./bottomSheetContext";

export type DescriptionProps = HTMLAttributes<HTMLParagraphElement>;

export const Description = forwardRef<HTMLParagraphElement, DescriptionProps>(
  ({ className, children, id: idProp, ...rest }, ref) => {
    const { setDescriptionId } = useBottomSheetContext();
    const generatedIdRef = useRef(generateId("ui-bottom-sheet-dialog-description-"));
    const id = idProp || generatedIdRef.current;

    useEffect(() => {
      setDescriptionId(id);
      return () => setDescriptionId(undefined);
    }, [id, setDescriptionId]);

    return (
      <p {...rest} ref={ref} id={id} className={classNames("ui-bottom-sheet-dialog-description", className)}>
        {children}
      </p>
    );
  },
);

Description.displayName = "BottomSheet.Description";
